import '~/components/pageHeaders.css';
import { EmployerInfoPanel } from './employer-info/EmployerInfoPanel';

export const EmployerInfoPage = () => {
  return (
    <section className="mobile-page-card w-full mx-auto rounded-xl border border-grey-900 bg-white p-5 text-left shadow-sm sm:p-8">
      <header className="mobile-page-header mb-5 border-b border-grey-900 pb-5 sm:mb-6 sm:pb-6">
        <h2 className="sub-heading-sb mb-2 text-grey-100">Employer Info</h2>
        <p className="body-text text-grey-200">Manage your organization information.</p>
      </header>
      <EmployerInfoPanel />
    </section>
  );
};
